<div id="markdownEditor">
    <angular-simplemde
        #editor
        [(input)]="content"
        (inputChange)="contentChange.emit(content)"
        [config]="config"
    ></angular-simplemde>
</div>
